import { Schema } from "effect";
export const EmailAddress = Schema.Struct({
    name: Schema.optional(Schema.String),
    address: Schema.NonEmptyString,
});
export const EmailRecipient = Schema.Struct({
    emailAddress: EmailAddress,
});
